"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeatherPage = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const Loader_1 = __importDefault(require("../../../../common/components/Loader/Loader"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const DayForecast_1 = __importDefault(require("../../../../common/components/Weather/DayForecast"));
const HourlyForecast_1 = __importDefault(require("../../../../common/components/Weather/HourlyForecast"));
const helpers_1 = require("../../../../common/helpers/helpers");
const globalVariables_1 = require("../../../../common/globalVariables");
const weatherHelpers_1 = require("../../../../common/helpers/weatherHelpers");
const WeatherPageWrapper = styled_components_1.default.div `
  position: absolute;
  top: 0;
  z-index: -1;
  min-height: 100%;
  width: 100%;
  padding: 8vh 7vmin 0 7vmin;
  overflow: hidden;
  background-color: ${(props) => props.theme.palette.mainAppColor.main};
  background-image: linear-gradient(
    180deg,
    rgba(212, 242, 255, 0.2) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  color: #ffffff;

  &.sunny {
    background: linear-gradient(330deg, #00416a, #d4f2ff);
  }

  &.rain {
    background: linear-gradient(
      to bottom right,
      rgba(174, 189, 194, 1),
      rgba(81, 90, 95, 1)
    );
  }

  &.snow {
    background: linear-gradient(
      to bottom right,
      rgba(173, 192, 214, 1),
      rgba(173, 192, 214, 1)
    );
  }

  &.night {
    background: linear-gradient(
      to bottom right,
      rgba(49, 83, 121, 1),
      rgba(0, 0, 0, 1)
    );
  }
  @media (max-width: ${(props) => props.maxWidth}px) {
    padding: 8vh 3vmin 0 3vmin;
  }
  @media (max-height: 415px) {
    padding-top: 45px;
  }
`;
const WeatherContainer = styled_components_1.default.div `
  max-width: ${(props) => props.maxWidth}px;
  margin: 0 auto;

  .current-weather {
    display: flex;
    justify-content: space-between;

    @media (orientation: landscape) {
      height: 32vh;
    }

    @media (orientation: portrait) {
      flex-direction: column;
      gap: 3vh;
      margin-top: 4vmin;
    }
  }

  .current-weather-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .now,
  .weather-location {
    color: #ffffff;
  }

  .now {
    text-transform: uppercase;
  }

  .now,
  .summary {
    font-size: 4.5vmin;
    font-weight: 400;
    color: white;

    @media (orientation: portrait) {
      font-size: 4vmin;
    }
  }

  .temperature {
    font-size: 12vmin;
    font-weight: 500;
    margin-right: 1.5vmin;
    margin-top: 3vmin;
    line-height: 11vmin;
    color: white;

    @media (orientation: portrait) {
      font-size: 9vmin;
      line-height: 9vmin;
    }
  }

  .weather-location {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .time-now {
    color: #ffffff;
    font-weight: 400;
    text-align: right;
    font-size: 4vmin;

    @media (orientation: portrait) {
      display: none;
    }
  }

  .time-portrait-mode {
    display: none;

    @media (orientation: portrait) {
      display: block;
    }
  }
`;
const CurrentTimeOfTheDay = styled_components_1.default.div `
  font-size: 4vmin;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  @media (orientation: portrait) {
    justify-content: center;

    .time {
      display: none;
    }
  }

  .provider {
    display: flex;
    align-items: center;
    margin-top: 16px;

    .provider-name {
      color: #fff;

      @media (orientation: landscape) {
        font-size: 24px;
      }
    }

    img {
      margin-right: 4px;
      height: 18px;

      @media (orientation: landscape) {
        height: 21px;
      }
    }
    @media (orientation: portrait) {
      position: absolute;
      bottom: 20px;
    }
  }
`;
const WeatherPage = (props) => {
    const { weatherData, timezone, venue, currentLocale } = props;
    (0, react_1.useEffect)(() => {
        window.scrollTo(0, 0);
    }, []);
    if (!weatherData) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (!weatherData.hourlyForecast) {
        return react_1.default.createElement(Loader_1.default, null);
    }
    const { symbol } = weatherData.hourlyForecast[0];
    const currentWeatherIsBad = !!(symbol === "rain" ||
        symbol === "snow" ||
        symbol === "sleet");
    const timeNow = helpers_1.Helpers.getDateFromStringDependingLocale(new Date().toISOString(), currentLocale, timezone).time;
    const weatherClass = (0, weatherHelpers_1.getWeatherClass)(weatherData, venue);
    return (react_1.default.createElement(WeatherPageWrapper, { maxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_HEADER, className: `${weatherClass}` },
        react_1.default.createElement(WeatherContainer, { maxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_HEADER },
            weatherData && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.Box, { className: "current-weather " },
                    react_1.default.createElement(material_1.Box, { className: "current-weather-container" },
                        react_1.default.createElement(material_1.Typography, { className: "now" },
                            " ",
                            i18n_js_1.default.t("dictionary.weather.now"),
                            " "),
                        react_1.default.createElement(material_1.Box, { className: "weather-location" },
                            react_1.default.createElement(material_1.Box, { display: "flex", alignItems: "flex-end" },
                                react_1.default.createElement(material_1.Typography, { className: "temperature" },
                                    " ",
                                    weatherData.current.temperature,
                                    "\u00B0",
                                    " "),
                                react_1.default.createElement(material_1.Typography, { className: "summary" },
                                    " ",
                                    weatherData.current.summary,
                                    " ")),
                            react_1.default.createElement(material_1.Box, { className: "time-now time-portrait-mode" },
                                " ",
                                timeNow,
                                " "))),
                    react_1.default.createElement(HourlyForecast_1.default, { forecast: weatherData.hourlyForecast })),
                react_1.default.createElement(DayForecast_1.default, { currentWeatherIsBad: currentWeatherIsBad, forecast: weatherData.forecast }))),
            react_1.default.createElement(CurrentTimeOfTheDay, null,
                weatherData.providerIcon && weatherData.providerText && (react_1.default.createElement("div", { className: "provider" },
                    react_1.default.createElement("img", { alt: "apple", src: weatherData.providerIcon }),
                    react_1.default.createElement(material_1.Typography, { className: "provider-name", variant: "body1" },
                        " ",
                        weatherData.providerText,
                        " "))),
                react_1.default.createElement("div", { className: "time" }, timeNow)))));
};
exports.WeatherPage = WeatherPage;
const mapStoreToProps = (store) => ({
    weatherData: store.getValue("weather"),
    timezone: store.getValue("timezone"),
    venue: store.getValue("venue"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.WeatherPage);
